let $ = jQuery;

/* Collection Tabs Data */ 
$(".collection_tabs_data").slick({
  dots: false,
  infinite: false,
  speed: 300,
  arrows: true,
  slidesToShow: 4,
  slidesToScroll: 4,
  adaptiveHeight: false,
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

/* Collection Tabs Slider */
$(".tab_header li").click(function () {
  $this = $(this);
  $target = $(this).attr("id");
  $section = $(this).attr("section");
  $($section + " .tab_header li.current").removeClass("current");
  $($this).addClass("current");
  $($section + " .tab-content").removeClass("show is-draggable");
  $($section + " .tab_data #" + $target).addClass("show is-draggable");
  $($section + " .tab_data #" + $target + " .slick-initialized").slick("refresh");
  window.dispatchEvent(new Event("resize"));
});
/* End */

// Icon slider
$('.ic_slider').slick({
  speed: 6000,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: 'linear',
  slidesToShow: 6,
  arrows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        speed: 6000,
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


// load More javascript
function loadMore(btn) {
  var $this = $(btn);
  $this.attr('disabled', true);
  $this.find('[load-more-text]').text("Loading...");
  var nextUrl = $('[data-next-link]').val();
  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function (responseHTML) {
      $('#product-grid').append($(responseHTML).find('#product-grid').html());
      $('#ProductGridContainer .load-more_wrap').html($(responseHTML).find('#ProductGridContainer .load-more_wrap').html());
    },
    complete: function () {
      let nextUrl = $('[data-next-link]').val();
      let btn = $('#ProductGridContainer .js-load-more');

      if (nextUrl) {
        btn.attr('disabled', false); btn.find('[load-more-text]').removeClass('hide');
      } else {
        btn.find('[load-more-text]').text("Products Finished").removeClass('hide'); btn.attr('disabled', true);
      }
    }
  })
}
// end javasrcipt

// Add active class on current page
jQuery(function($) {
  var path = window.location.href; 
  // because the 'href' property of the DOM element is the absolute path
  $('.collection-list a').each(function() {
    if (this.href === path) {
      $(this).addClass('active');
    }
  });
});

// FAQ Script
$('.titleWrapper').click(function () {
    var toggle = $(this).next('div#descwrapper');
    $(toggle).slideToggle("slow");
  });
  $('.inactive').click(function () {
    $(this).toggleClass('inactive active');
  });

// New tab links
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
